/**
 * Converts a given amount to its percentage representation of a total.
 *
 * @param amount - The part value to be converted to a percentage.
 * @param total - The total value against which the percentage is calculated.
 * @returns The percentage value of the amount with respect to the total.
 *          Returns 0 if the total is less than or equal to 0 to avoid division by zero.
 *          Can be a number between - and 100 inclusive.  May include decimal places.
 *
 */

const toPercentage = (amount: number = 0, total: number = 0): number => {
  return total <= 0 ? 0 : (amount / total) * 100;
};

export default toPercentage;
